let scriptsLoaded = false;

function loadScripts() {
  if (scriptsLoaded) return;
  scriptsLoaded = true;

  // Initialize tooltips
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return bootstrap.Tooltip.getInstance(tooltipTriggerEl) || new bootstrap.Tooltip(tooltipTriggerEl)
  });
}

// Load scripts on first scroll
window.addEventListener('scroll', function () {
  loadScripts();
}, { once: true });

export { loadScripts };
